export const DEFAULT_TABS = {
  HOMEBUYER: 1,
};

export const FILTER_TABS = {
  FEATURES: 2,
  NEARBY: 3,
};
